import React from "react";
import { ProductConsumer } from "../../Context/AddProWakel";
const FillAddUser = () => {
  const roles = [
    { value: "6", label: "User" },
    { value: "8", label: "Ipad" },
    { value: "9", label: "IpadAdmin" },
    { value: "7", label: "Admin" }
  ];
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            AddProChange,
            A_bakarhenar,
            A_zh_mobile,
            onSaveAddUser,
            radiochange,
            A_password,
            clear_edit,
            updtae_User,
            edit,
            A_newPassword,
            A_openmodel,
            A_passCheck
          } = value;
          return (
            <>
              <div className="col-12 col-10 col-lg-5">
                <div className="card card-primary">
                  <div
                    className="card-header"
                    style={{ backgroundColor: "#2C3539" }}
                  >
                    <h4 className="card-title tc text-warning font-weight-bold">
                      زیادکردنی بەکارهینەر
                    </h4>
                  </div>

                  <form style={{ color: "#2C3539" }}>
                    <div className="card-body text-right">
                      <div className="form-group">
                        <label className="font-weight-bold f4">
                          :ناوی بەکارهێنەر
                        </label>
                        <input
                          type="text"
                          name="A_bakarhenar"
                          value={A_bakarhenar}
                          onChange={AddProChange}
                          className="form-control text-right font-weight-bold"
                          placeholder="...تۆمار کردن"
                          disabled={A_openmodel ? null : true}
                        />
                      </div>
                      <div className="form-group">
                        {edit == null ? (
                          <>
                            <label className="font-weight-bold f4">
                              :وشەی نهێنی
                            </label>
                            <input
                              type="password"
                              value={A_password}
                              name="A_password"
                              onChange={AddProChange}
                              className="form-control text-right font-weight-bold"
                              placeholder="...تۆمار کردن"
                              disabled={A_openmodel ? null : true}
                            />
                          </>
                        ) : (
                          <>
                            <label className="font-weight-bold f4">
                              :وشەی نهێنی کۆن
                            </label>
                            <input
                              type="password"
                              value={A_password}
                              name="A_password"
                              onChange={AddProChange}
                              className="form-control text-right font-weight-bold"
                              placeholder="...تۆمار کردن"
                              disabled={A_openmodel ? null : true}
                            />
                            <label className="font-weight-bold f4">
                              : وشەی نهێنی نوێ
                            </label>
                            <input
                              type="password"
                              value={A_newPassword}
                              name="A_newPassword"
                              onChange={AddProChange}
                              className="form-control text-right font-weight-bold"
                              placeholder="...تۆمار کردن"
                              disabled={A_openmodel ? null : true}
                            />
                          </>
                        )}
                      </div>

                      <div className="form-group">
                        <label className="font-weight-bold f4">
                          :ژ.مۆبایەل
                        </label>
                        <input
                          type="text"
                          name="A_zh_mobile"
                          value={A_zh_mobile == 0 ? "" : A_zh_mobile}
                          onChange={AddProChange}
                          className="form-control text-right font-weight-bold"
                          placeholder="...تۆمار کردن"
                          disabled={A_openmodel ? null : true}
                        />
                      </div>
                      <div className="form-group">
                        <label className="font-weight-bold f4">
                          :وشەی نهێنی فرۆشتن
                        </label>
                        <input
                          type="password"
                          name="A_passCheck"
                          value={A_passCheck == 0 ? "" : A_passCheck}
                          onChange={AddProChange}
                          className="form-control text-right font-weight-bold"
                          placeholder="...تۆمار کردن"
                          disabled={A_openmodel ? null : true}
                        />
                      </div>
                      <div
                        className="p-4 rounded-lg border border-gray-200 bold"
                        onChange={radiochange}
                      >
                        <label className="block text-gray-700 text-right font-bold mb-3">
                          :ڕۆڵی بەکارهێنەر
                        </label>
                        <div className="flex flex-wrap justify-end gap-4">
                          <div className="relative flex items-center">
                            <input
                              className="hidden peer"
                              type="radio"
                              value="6"
                              name="role"
                              id="role-user"
                            />
                            <label
                              htmlFor="role-user"
                              className="px-4 py-2 bg-white border-2 border-gray-300 rounded-lg 
                 cursor-pointer select-none
                 peer-checked:border-yellow-500 peer-checked:bg-yellow-50
                 hover:bg-gray-50"
                            >
                              User
                            </label>
                          </div>
                          {/* <div className="relative flex items-center">
                            <input
                              className="hidden peer"
                              type="radio"
                              value="8"
                              name="role"
                              id="role-ipad"
                            />
                            <label
                              htmlFor="role-ipad"
                              className="px-4 py-2 bg-white border-2 border-gray-300 rounded-lg 
                 cursor-pointer select-none
                 peer-checked:border-yellow-500 peer-checked:bg-yellow-50
                 hover:bg-gray-50"
                            >
                              Ipad
                            </label>
                          </div> */}
                          {/* <div className="relative flex items-center">
                            <input
                              className="hidden peer"
                              type="radio"
                              value="9"
                              name="role"
                              id="role-ipadadmin"
                            />
                            <label
                              htmlFor="role-ipadadmin"
                              className="px-4 py-2 bg-white border-2 border-gray-300 rounded-lg 
                 cursor-pointer select-none
                 peer-checked:border-yellow-500 peer-checked:bg-yellow-50
                 hover:bg-gray-50"
                            >
                              IpadAdmin
                            </label>
                          </div> */}
                          <div className="relative flex items-center">
                            <input
                              className="hidden peer"
                              type="radio"
                              value="7"
                              name="role"
                              id="role-admin"
                            />
                            <label
                              htmlFor="role-admin"
                              className="px-4 py-2 bg-white border-2 border-gray-300 rounded-lg 
                 cursor-pointer select-none
                 peer-checked:border-yellow-500 peer-checked:bg-yellow-50
                 hover:bg-gray-50"
                            >
                              Admin
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="card-footer"
                      style={{ backgroundColor: "#2C3539" }}
                    >
                      {edit == null ? (
                        <button
                          type="button"
                          onClick={onSaveAddUser}
                          className="btn btn-warning fk"
                        >
                          تۆمار کردن
                        </button>
                      ) : (
                        <>
                          <button
                            type="button"
                            onClick={(e) => updtae_User(e, edit)}
                            className="btn btn-primary"
                          >
                            گۆڕین
                          </button>
                          <button
                            type="button"
                            onClick={clear_edit}
                            className="btn btn-primary ml3"
                          >
                            <i className="fas fa-window-close "></i>
                          </button>
                        </>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};
export default FillAddUser;
